
import { FLIGHT_ITINERARY_TYPE, FLIGHT_ITINERARY_TYPE_MICRO } from "@app/enums";
import { LegAWSInt, PassengerAWSInt } from "@app/interfaces/reservation-aws.interface";
import { Segment } from "@app/models/cart/segment.model";
import { Passenger } from "@app/models/micro/passenger.model";
import { Reservation } from "@app/models/micro/reservation.model";
import { environment } from "@env/environment";

export class PnrAWSMapper {

  private static reservations: Reservation[];

  constructor() { }

  /**
   * Resuelve el leg operativo priorizando salidas desde el aeropuerto del kiosko,
   * luego aplica la ventana CKI / MYB / CLOSED
   */
  private static selectBookedLeg(
    legs: LegAWSInt[] | undefined,
    kioskLocation: string
  ): LegAWSInt | undefined {
    if (!legs?.length) {
      return undefined;
    }

    const pool = PnrAWSMapper.legsDepartingFrom(kioskLocation, legs);

    let bookedLeg = pool.find((leg) =>
      leg.segments?.some((segment) => segment.windowSegmentStatus === 'CKI')
    );

    if (!bookedLeg) {
      const bookedLegs = pool.filter((leg) =>
        leg.segments?.some(
          (segment) =>
            segment.windowSegmentStatus === 'IN_FLIGHT' ||
            segment.windowSegmentStatus === 'MYB' ||
            segment.windowSegmentStatus === 'CLOSED'
        )
      );
      bookedLeg = bookedLegs.find(
        (leg) =>
          leg.windowLegStatus === 'IN_FLIGHT' || leg.windowLegStatus === 'MYB'
      );
      if (!bookedLeg) {
        bookedLeg = bookedLegs.reverse()[0];
      }
    }

    return bookedLeg;
  }

  private static legsDepartingFrom(
    kioskLocation: string,
    legs: LegAWSInt[]
  ): LegAWSInt[] {
    if (!kioskLocation) {
      return legs;
    }
    const atKiosk = legs.filter((leg) =>
      leg.segments?.some((seg) => seg.departureAirport === kioskLocation)
    );
    return atKiosk.length > 0 ? atKiosk : legs;
  }

  static pnrBuild(pnr, location) {
    this.reservations = [];
    let reservation: Reservation;

    if (pnr) {
      // Verificar FARELOCK antes de validaciones
      if (pnr.typeReservation === 'FARELOCK') {
        throw ({ code: 'FARELOCK', msg: 'FARELOCK reservation status', typeReservation: 'FARELOCK', rawData: pnr });
      }
      let oldLegs = pnr.oldBookedLegCollection;
      let legs:any[] = pnr.bookedLegCollection;
      let kioskLocation = location

      const flightType = {
        [FLIGHT_ITINERARY_TYPE_MICRO.ONEWAY]: FLIGHT_ITINERARY_TYPE.ONEWAY,
        [FLIGHT_ITINERARY_TYPE_MICRO.ROUNDTRIP]: FLIGHT_ITINERARY_TYPE.ROUNDTRIP,
        [FLIGHT_ITINERARY_TYPE_MICRO.MULTICITY]: FLIGHT_ITINERARY_TYPE.MULTICITY,
      };
      let bookedLeg = this.selectBookedLeg(legs, kioskLocation);
      let oldBookedLeg = this.selectBookedLeg(oldLegs, kioskLocation);

      if (bookedLeg) {
        reservation = new Reservation({ pnrCode: pnr.reservationCode, pnr, leg: bookedLeg, oldLeg: oldBookedLeg, kioskLocation });
        const indexLeg = legs.findIndex(leg=> leg.legCode == bookedLeg.legCode);
        reservation.flightItineraryType = flightType[pnr.tripType];
        reservation.flightSummary.itineraryPartType = indexLeg ==  1 && reservation.flightItineraryType == FLIGHT_ITINERARY_TYPE.ROUNDTRIP ?  'inbound' : 'outbound';

        if (pnr.corporateRecognition) {
          if (pnr.corporateRecognition && pnr.corporateRecognition.logo) {
            pnr.corporateRecognition.companyLogo = `${environment.cmsUrl}/sites/default/files/${pnr.corporateRecognition.spid}.png`
          }
        }
        reservation.passengers = this.buildPassengers(pnr.passengers, reservation)
        reservation.isAgencyReservation = pnr.isAgencyReservation
        reservation.isStandByBooking = this.isStandByBooking(pnr.passengers);
        const onHoldNnoTickets = reservation.passengers.some((p)=> !p.ticketInfo)
        if(onHoldNnoTickets) {
          throw ({code:20, msg:"error on hold"})
        }
        this.reservations.push(reservation);
      }
    }

    return this.reservations;
  }

  private static buildPassengers(passengers: PassengerAWSInt[],reservation?:Reservation): Passenger[] {
    let paxes: Passenger[] = [];

    if (passengers && passengers.length > 0) {
      for (let paxIndex of passengers) {
        let passenger = new Passenger(paxIndex,reservation); // .buildBagsUsedByRemarks(reservation.remarks);
        paxes.push(passenger);
      }
    }

    return paxes;
  }

  private static isStandByBooking(passengers) {
    for (let index = 0; index < passengers.length; index++) {
      let passenger = passengers[index];

      if (passenger.passengerType === 'E') {
        return true;
      }
    }

    return false;
  }
}
